import React, { useState, useContext } from "react";
import {
  Fab,
  Typography,
  Grid,
  TextField,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { LangContext } from "../../Context/Langcontext";
import useReactRouter from "use-react-router";

const useStyle = makeStyles((theme) => ({
  textfield: {
    "& .MuiInputBase-input": {
      height: "2rem",
      fontWeight: 200,
    },
    marginBottom: "1.5rem",
  },
}));
const Stepone = ({ setstep, setpage, input, setinput }) => {
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();

  const classes = useStyle();
  const [error, setError] = useState({
    statusEmail: false,
    email: "",
    statusPassword: false,
    password: "",
    statusCpassword: false,
    cpassword: "",
  });
  const [focusIcon, setFocusIcon] = useState({
    showPassword: false,
    showcPassword: false,
  });
  const handleChange = (e) => {
    setinput({ ...input, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let passwordError = "";
    let cpasswordlError = "";

    if (input.password.length < 8) {
      passwordError = lang.Password8;
    }

    if (input.password !== input.cpassword) {
      cpasswordlError = lang.PasswordNotMatch;
    }

    if (cpasswordlError || passwordError) {
      setError({
        ...error,
        statusPassword: input.password.length < 8 ? true : false,
        password: input.password.length < 8 ? passwordError : "",
        statusCpassword: input.cpassword !== input.password ? true : false,
        cpassword: input.cpassword !== input.password ? cpasswordlError : "",
      });
      return false;
    }

    return true;
  };

  const Nextstate = (e) => {
    e.preventDefault();
    const isvalid = validate();
    if (isvalid) {
      setstep(1);
    } else {
    }
  };
  return (
    <div>
      <form onSubmit={Nextstate}>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              required
              id="outlined-name"
              label={lang.Email}
              fullWidth
              className={classes.textfield}
              value={input.email}
              name="email"
              type="email"
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusEmail: false, email: "" });
              }}
              error={error.statusEmail}
              helperText={error.email}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id="outlined-name"
              label={lang.Password}
              fullWidth
              className={classes.textfield}
              type={focusIcon.showPassword ? "text" : "password"}
              value={input.password}
              name="password"
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusPassword: false, password: "" });
              }}
              error={error.statusPassword}
              helperText={error.password}
              InputProps={{
                endAdornment: (
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={() => {
                      setFocusIcon({
                        ...focusIcon,
                        showPassword: !focusIcon.showPassword,
                      });
                    }}
                  >
                    {focusIcon.showPassword ? (
                      <MdVisibility />
                    ) : (
                      <MdVisibilityOff />
                    )}
                  </IconButton>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id="outlined-name"
              label={lang.ConfirmPassword}
              fullWidth
              type={focusIcon.showcPassword ? "text" : "password"}
              className={classes.textfield}
              value={input.cpassword}
              name="cpassword"
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusCpassword: false, cpassword: "" });
              }}
              error={error.statusCpassword}
              helperText={error.cpassword}
              InputProps={{
                endAdornment: (
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={() => {
                      setFocusIcon({
                        ...focusIcon,
                        showcPassword: !focusIcon.showcPassword,
                      });
                    }}
                  >
                    {focusIcon.showcPassword ? (
                      <MdVisibility />
                    ) : (
                      <MdVisibilityOff />
                    )}
                  </IconButton>
                ),
              }}
            />
          </Grid>
        </Grid>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Fab
            variant="extended"
            aria-label="signin"
            color="secondary"
            style={{ boxShadow: "unset" }}
            onClick={() => {
              setpage(0);
              history.push("/user/login");
            }}
          >
            <Typography variant="h6" component="p" style={{ color: "white" }}>
              {lang.Cancel}
            </Typography>
          </Fab>

          <Fab
            variant="extended"
            aria-label="signin"
            color="primary"
            type="submit"
            style={{ boxShadow: "unset" }}
            // onClick={() => {
            //   Nextstate();
            // }}
          >
            <Typography variant="h6" component="p" style={{ color: "white" }}>
              {lang.Next}
            </Typography>
          </Fab>
        </div>
      </form>
    </div>
  );
};

export default Stepone;
